module.exports = __webpack_public_path__ + "static/media/arrow-circle-down.8e09c43b.svg";